export default __webpack_public_path__ + "static/media/error.2902e31f.png";